import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { WebApiService } from "../../../_libs/web-api";
import { BaseWebApiService } from "./-base-webapi.service";
import { SuggestedAddress } from "./models/suggestedAddress.model";
import { Option } from "./models/option.model";
import { Suburb } from "./models/suburb.model";
import { EnvConfigProvider } from "./env-config.provider";
import { map } from "rxjs/operators";
import { SalutationResponse, Datum } from "./models/salutation.model";
// import { Zeus } from "./models/zeus.models";
import { IsServiceNumberPortableResponse } from "./models/address.model";
import { forkJoin } from "rxjs";
import { IAddressesSearchResult } from "../_models";

@Injectable({
	providedIn: "root"
})
export class AddressService extends BaseWebApiService {
	constructor(private webApiService: WebApiService) {
		super();
	}

	public suggestion(partialAddress: string): Observable<SuggestedAddress[]> {
		console.log("suggestions : ", partialAddress);
		const url = "/api/address/Suggestion?address={partialAddress}";

		return this.webApiService.get(
			this.getFullUrl(
				this.valueReplacer(
					url,
					["partialAddress"],
					[encodeURIComponent(partialAddress.trim())]
				)
			)
		);
	}

	public muleAddressSuggestion(partialAddress: string): Observable<IAddressesSearchResult> {
		const url = "addressmgmt/compositeAddress?partialText={partialAddress}";
		return this.webApiService.getMS(
			this.valueReplacer(
				url,
				["partialAddress"],
				[encodeURIComponent(partialAddress.trim())]
			)
		);
	}

	public states(): Observable<Option[]> {
		const url = "/api/address/States";
		return this.webApiService.get(this.getFullUrl(url));
	}

	public suburbFromPostcode(postcode: string): Observable<Suburb[]> {
		const url = "/api/address/suburb?postcode={postcode}";

		return this.webApiService.get(
			this.getFullUrl(this.valueReplacer(url, ["postcode"], [postcode]))
		);
	}

	public unitTypes(): Observable<Option[]> {
		const url = "/api/address/buildingtypes";
		return this.webApiService.get(this.getFullUrl(url));
	}

	public streetTypes(): Observable<Option[]> {
		const url = "/api/address/StreetTypes";
		return this.webApiService.get(this.getFullUrl(url));
	}

	public manualAddressLookupData(): Observable<{
		unitTypes: Option[];
		streetTypes: Option[];
	}> {
		const unitTypes = this.unitTypes();
		const streetTypes = this.streetTypes();

		return forkJoin([unitTypes, streetTypes]).pipe(
			map(
				result =>
					<any>{
						unitTypes: result[0],
						streetTypes: result[1]
					}
			)
		);
	}

	public salutations(): Observable<Option[]> {
		const url = "/jsonapi/taxonomy_term/salutation";
		return this.webApiService.get(this.getFullUrl(url, true)).pipe(
			map((response: SalutationResponse) =>
				response.data.map((d: Datum) => ({
					Key: d.attributes.name.toLocaleLowerCase(),
					Value: d.attributes.name
				}))
			)
		);
	}

	public getFragmentedAddressFromGNAF(
		gnaf: string
	): Observable<any>{ // Zeus.FragmentedAddressFromGNAF> {
		const url = `/api/address/Address?gnafId=${gnaf}`;
		return this.webApiService.get(this.getFullUrl(url));
	}

	public isServiceNumberPortable(serviceNumber: string): Observable<boolean> {
		const url =
			"/api/plnr/check?organisationType={orgType}&serviceNumber={serviceNumber}";

		const isPortable = this.webApiService
			.get(
				this.getFullUrl(
					this.valueReplacer(
						url,
						["orgType", "serviceNumber"],
						["2", serviceNumber.replace(/[^0-9]*/g, "")]
					)
				)
			)
			.pipe(
				map(
					(response: IsServiceNumberPortableResponse) =>
						response.IsPortable
				)
			);

		return isPortable;
	}
}
